import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const ZalopayPaymentMob = () => {
  return <CommonProcess />;
};

export default ZalopayPaymentMob;
